/**
 * System Event Log Entity Schemas
 *
 * Types for system audit/event logs displayed in the admin dashboard.
 */

import { z } from 'zod'

/**
 * Event severity levels
 */
export const EventSeveritySchema = z.enum(['INFO', 'WARN', 'ERROR', 'CRITICAL'])
export type EventSeverity = z.infer<typeof EventSeveritySchema>

/**
 * Actor information attached to an event log
 */
export const EventLogActorSchema = z.object({
  id: z.string(),
  email: z.string().nullable(),
  firstName: z.string().nullable(),
  lastName: z.string().nullable()
})

export type EventLogActor = z.infer<typeof EventLogActorSchema>

/**
 * School information attached to an event log
 */
export const EventLogSchoolSchema = z.object({
  id: z.string(),
  name: z.string()
})

export type EventLogSchool = z.infer<typeof EventLogSchoolSchema>

/**
 * A single system event log entry
 */
export const EventLogSchema = z.object({
  id: z.string(),
  eventType: z.string(),
  description: z.string().nullable(),
  severity: EventSeveritySchema,
  source: z.string().nullable(),
  eventTimestamp: z.coerce.date(),
  metadata: z.any().nullable(),
  school: EventLogSchoolSchema.nullable(),
  actor: EventLogActorSchema.nullable()
})

export type EventLog = z.infer<typeof EventLogSchema>
